import { normalizeApiBaseUrl } from '@peanuds/shared/api/normalize-api-base-url';

const appConfig = (() => {
  const configObject: Partial<ImportMetaEnv> = {
    VITE_TITLE: import.meta.env.VITE_TITLE,
    VITE_BASE_URL: import.meta.env.VITE_BASE_URL,
    VITE_API_URL: normalizeApiBaseUrl(import.meta.env.VITE_API_URL),
    VITE_WEBSOCKET_URL: import.meta.env.VITE_WEBSOCKET_URL,
    VITE_PUBLIC_POSTHOG_KEY: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
    VITE_PUBLIC_POSTHOG_REVERSE_PROXY_HOST: import.meta.env.VITE_PUBLIC_POSTHOG_REVERSE_PROXY_HOST,
    VITE_PUBLIC_SENTRY_DSN: import.meta.env.VITE_PUBLIC_SENTRY_DSN,
    VITE_FEATURE_FLAGS: import.meta.env.VITE_FEATURE_FLAGS,
    VITE_BATCH_PAYMENTS_CLIENT_ID: import.meta.env.VITE_BATCH_PAYMENTS_CLIENT_ID,
    VITE_HIDE_ACCOUNT_STATEMENT_CLIENT_ID: import.meta.env.VITE_HIDE_ACCOUNT_STATEMENT_CLIENT_ID,
    VITE_ENV_NAME: import.meta.env.VITE_ENV_NAME,
    VITE_AUTH0_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN,
    VITE_AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID,
    VITE_AUTH0_AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE,
    VITE_AUTH0_CONNECTION: import.meta.env.VITE_AUTH0_CONNECTION,
    VITE_AUTH_MODE: import.meta.env.VITE_AUTH_MODE,
    VITE_HUBSPOT_HUB_ID: import.meta.env.VITE_HUBSPOT_HUB_ID,
    VITE_HUBSPOT_CHAT_ENABLED: import.meta.env.VITE_HUBSPOT_CHAT_ENABLED,
    VITE_HUBSPOT_PREORDER_FORM_ID: import.meta.env.VITE_HUBSPOT_PREORDER_FORM_ID,
  };

  return configObject;
})();

const isE2eMode = appConfig.VITE_AUTH_MODE === 'e2e';

export { appConfig, isE2eMode };
